import { render, staticRenderFns } from "./TxnProcessBizumForm.vue?vue&type=template&id=1def3073&"
import script from "./TxnProcessBizumForm.vue?vue&type=script&lang=ts&"
export * from "./TxnProcessBizumForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports